import React from "react";
import { LoaderCircle, Plus, RefreshCw, Webhook } from "lucide-react";

function WebhookEmpty({ canManageConnection, onCreate, creating, error, onRefresh }) {
  return (
    <div className="min-w-0">
        <div className="rounded-[22px] border border-[#d8e7ed] bg-white p-10 text-center shadow-[0_16px_44px_rgba(15,43,66,0.06)] dark:border-dark-border dark:bg-dark-card">

          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-[15px] border border-[#b9dff0] bg-[#edf8fd] text-[#147db5] dark:border-dark-primary/45 dark:bg-dark-soft-blue dark:text-dark-primary">
            <Webhook size={18} />
          </div>

          <h3 className="mt-4 text-[13px] font-bold text-[#344f61] dark:text-dark-text-primary">
            No webhook configured
          </h3>

          <p className="mx-auto mt-1.5 max-w-sm text-[10px] leading-5 text-[#8194a0] dark:text-dark-text-muted">
            {canManageConnection
              ? "Create a callback URL and verification token for this phone number, then use them to set up event delivery in Meta."
              : "Your organisation owner or admin needs to create the webhook for this phone number. Refresh after setup is complete."}
          </p>

          {error && (
            <p role="alert" className="mx-auto mt-4 max-w-sm text-xs leading-5 text-red-600 dark:text-red-400">
              {error}
            </p>
          )}

          <button
            type="button"
            onClick={canManageConnection ? onCreate : onRefresh}
            disabled={creating}
            className="mx-auto mt-5 inline-flex min-h-10 items-center justify-center gap-2 rounded-xl bg-[#147db5] px-4 text-xs font-bold text-white transition hover:bg-[#0f5b8a] disabled:cursor-not-allowed disabled:opacity-60 dark:bg-dark-primary dark:hover:bg-dark-primary-hover"
          >
            {creating ? <LoaderCircle size={15} className="animate-spin" /> : canManageConnection ? <Plus size={15} /> : <RefreshCw size={15} />}
            {creating ? "Creating webhook..." : canManageConnection ? "Create webhook" : "Refresh status"}
          </button>
        </div>
    </div>
  );
}

export default WebhookEmpty;
